export function calculate_payment_amount(
    donate_like_history=true,
    donate_search_history=true,
    donate_share_history=true,
    donate_session_times=true,
    donate_favorites=true,
    donate_following=true,
    donate_followers=true,
    donate_comments=true,
    donate_comments_text=true,
    donate_ads=true,
    donate_settings=true,
    survey_completed=false,
) {

    const WATCH_HISTORY = 5;
    const OTHER_AMOUNT = 1;
    const SURVEY_AMOUNT = 0;

    var payment_amount = WATCH_HISTORY;

    const optional_fields = [donate_like_history, donate_search_history, donate_share_history, donate_session_times, donate_favorites, donate_followers, donate_following, donate_ads, donate_settings];
    for (var i = 0; i < optional_fields.length; i++){ 
        if(optional_fields[i]==true){
            // console.log(optional_fields[i]);
            payment_amount+=OTHER_AMOUNT
        }
    }
    if(donate_comments == true){
        payment_amount += OTHER_AMOUNT;
        if (donate_comments_text == true){
            payment_amount += OTHER_AMOUNT;
        }
    }

    if (survey_completed==true) {
        payment_amount+=SURVEY_AMOUNT;
    }

    return payment_amount;
}

export function calculate_payment_amount_instagram(
    donation_InstagramAdsAndBusinesses=true,
    donation_InstagramYourTopics=true,
    donation_InstagramAppsAndWebsites=true,
    donation_InstagramRecentSearches=true,
    donation_InstagramLinkHistory=true,
    donation_InstagramSubscriptions=true,
    donation_InstagramStoryInteractions=true,
    donation_InstagramSaved=true,
    donation_InstagramLikes=true,
    donation_InstagramComments=true,
    survey_completed=false,
) {

    const ADS_AND_TOPICS = 2;
    const LIKE_HISTORY = 2;
    const OTHER_AMOUNT = 1;
    const SURVEY_AMOUNT = 0;

    var payment_amount = ADS_AND_TOPICS + LIKE_HISTORY;

    const optional_fields = [
        donation_InstagramAdsAndBusinesses,
        donation_InstagramYourTopics,
        donation_InstagramAppsAndWebsites,
        donation_InstagramRecentSearches,
        donation_InstagramLinkHistory,
        donation_InstagramSubscriptions,
        donation_InstagramStoryInteractions,
        donation_InstagramSaved,
        donation_InstagramComments,        
    ];

    for (var i = 0; i < optional_fields.length; i++){ 
        if (optional_fields[i]==true) {
            payment_amount += OTHER_AMOUNT;
        }
    }

    if (survey_completed==true) {
        payment_amount += SURVEY_AMOUNT;
    }

    return payment_amount;
}